<template>
  <div id="visit">
    <header-top showBack></header-top>
    <!-- <div class="header-title show-back">基础信息</div> -->
    <el-form
      ref="visitInfo"
      :model="visitInfo"
      label-width="7rem"
      label-position="left"
    >
      <div class="basics-deail">
        <div class="detail-tit">基础信息</div>
        <el-row>
          <el-col>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  prop="estateInfo"
                  label="报备楼盘"
                  class="auto-height"
                  v-if="reservationInfo.estateInfo"
                >
                  <div class="estate-info">
                    <div class="estate-main">
                      <img
                        class="estate-cover"
                        v-if="!reservationInfo.estateInfo.hasCover"
                        src="@/assets/image/estate-cover.jpg"
                        alt=""
                      />
                      <img
                        class="estate-cover"
                        v-if="reservationInfo.estateInfo.hasCover"
                        :src="reservationInfo.estateInfo.photoCoverUrl"
                        alt=""
                      />
                      <div class="edtate-detail">
                        <div class="name">
                          {{ reservationInfo.estateInfo.estateName
                          }}<span class="status">{{
                            reservationInfo.estateInfo.saleStatus
                          }}</span>
                        </div>
                        <div class="address">
                          {{ reservationInfo.estateInfo.city }}-{{
                            reservationInfo.estateInfo.street
                          }}-{{ reservationInfo.estateInfo.business }}
                        </div>
                        <div class="info">
                          报备号码: {{ ruleInfo.numberType | nullValue }} |
                          报备有效时长 ：{{
                            ruleInfo.protectedNumber | nullValue
                          }}{{ ruleInfo.protectedUnit | nullValue }}
                          <!-- 报备号码: -- | 提前报备时长：-- | 报备有效时长 ：-- -->
                        </div>
                      </div>
                    </div>
                    <div class="estate-price">
                      {{ reservationInfo.estateInfo.minPrice }}元/㎡
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div class="flex reservation-items">
          <div class="reservation-item">
            <el-form-item prop="customerName" label="客户姓名">
              <span>{{ reservationInfo.customerName | nullValue }}</span>
            </el-form-item>
          </div>
          <div class="reservation-item">
            <el-form-item prop="customerPhoneNumber" label="客户号码">
              <span>{{ reservationInfo.customerPhoneNumber | nullValue }}</span>
            </el-form-item>
          </div>
          <div class="reservation-item">
            <el-form-item prop="creatorName" label="经纪人姓名">
              <span>{{ reservationInfo.creatorName | nullValue }}</span>
            </el-form-item>
          </div>
          <div class="reservation-item">
            <el-form-item prop="creatorPhoneNumber" label="经纪人号码">
              <span>{{ reservationInfo.creatorPhoneNumber | nullValue }}</span>
            </el-form-item>
          </div>
          <div class="reservation-item">
            <el-form-item prop="channelName" label="分销商姓名">
              <span>{{ reservationInfo.channelName | nullValue }}</span>
            </el-form-item>
          </div>
          <div class="reservation-item">
            <el-form-item prop="channelOrganizationUnit" label="分销商所属机构">
              <span>{{ reservationInfo.channelOrganizationUnit | nullValue }}</span>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="netsign-detail" v-if="showNetsign && isEdit != 'netsign'">
        <div class="detail-tit">
          签约信息<span @click="edit('netsign')" v-if="flowStatus != '签约'"
            >管理</span
          >
        </div>
        <div class="flex reservation-items">
          <div class="reservation-item">
            <el-form-item prop="creationTime" label="签约日期">
              <span>{{ netsignInfo.netSignTime | nullValue }}</span>
            </el-form-item>
            <el-form-item prop="buildingNumber" label="楼栋号">
              <span>{{ netsignInfo.buildingNumber | nullValue }}</span>
            </el-form-item>
            <el-form-item prop="unitNumber" label="单元号">
              <span>{{ netsignInfo.unitNumber | nullValue }}</span>
            </el-form-item>
            <el-form-item prop="houseNumber" label="房间号">
              <span>{{ netsignInfo.houseNumber | nullValue }}</span>
            </el-form-item>
            <el-form-item prop="price" label="价格">
              <span>{{ netsignInfo.price | nullValue }}万元</span>
            </el-form-item>
            <el-form-item prop="more" label="备注">
              <span>{{ netsignInfo.more | nullValue }}</span>
            </el-form-item>
          </div>
          <div class="reservation-item">
            <el-form-item
              prop="materials"
              label="附件"
              class="auto-height margin-bottom"
            >
              <div class="visit-img" v-if="netsignInfo.materials.length">
                <el-image
                  class="photo-item"
                  v-for="(item, index) in netsignInfo.materials"
                  :key="index"
                  :src="item.url"
                ></el-image>
              </div>
              <div v-else>—</div>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="netsign-detail" v-if="showNetsign && isEdit == 'netsign'">
        <div class="detail-tit">签约信息</div>
        <el-row>
          <el-col :span="12">
            <el-form
              :model="netsignForm"
              ref="netsignForm"
              :rules="netSignRules"
              label-width="6rem"
              label-position="left"
              class="netsign-form"
            >
              <el-form-item label="房源" class="auto-height" required>
                <div class="house-info">
                  <el-form-item prop="buildingNumber">
                    <el-input v-model="netsignForm.buildingNumber"></el-input
                    ><span class="unit">栋</span>
                  </el-form-item>
                  <el-form-item prop="unitNumber">
                    <el-input v-model="netsignForm.unitNumber"></el-input
                    ><span class="unit">单元</span>
                  </el-form-item>
                  <el-form-item prop="houseNumber">
                    <el-input v-model="netsignForm.houseNumber"></el-input
                    ><span class="unit">号</span>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item prop="netSignTime" label="成交日期">
                <el-date-picker
                  v-model="netsignForm.netSignTime"
                  align="center"
                  type="date"
                  placeholder="请选择成交日期"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="price" label="成交价格">
                <el-input
                  class="reason-box"
                  v-model="netsignForm.price"
                  type="number"
                  placeholder="请输入成交价格"
                >
                  <template slot="append">万元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="附件" class="auto-height">
                <div class="visit-img">
                  <div
                    class="photo-item"
                    v-for="(item, index) in netsignForm.materials"
                    :key="index"
                  >
                    <div class="img-box">
                      <img :src="item.url" class="photo-img" />
                      <div class="del-btn">
                        <span @click="delNetsignPhotoItme(index, 'materials')"
                          >删除</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="photo-item"
                    v-for="(item, index) in uploadPhotoList"
                    :key="index"
                  >
                    <div class="img-box">
                      <img :src="item.url" class="photo-img" />
                      <div class="del-btn">
                        <span @click="delRecognitionPhotoItme(index)"
                          >删除</span
                        >
                      </div>
                    </div>
                  </div>
                  <el-upload
                    ref="upload"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-change="handlePictureCardPreview"
                    :show-file-list="false"
                    :auto-upload="false"
                    multiple
                    accept=".jpg, .png, .jpeg"
                  >
                    <div class="upload-btn">
                      <i slot="default" class="el-icon-plus"></i>
                      <span>最多上传5张图片</span>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item prop="more" label="备注" class="auto-height">
                <el-input
                  class="reason-box"
                  type="textarea"
                  v-model="netsignForm.more"
                  maxlength="200"
                  placeholder="请输入备注"
                  show-word-limit
                  resize="none"
                ></el-input>
              </el-form-item>
              <el-form-item class="btn">
                <el-button @click="closeEdit">取消</el-button>
                <el-button
                  type="primary"
                  @click="submitanetsignForm('netsignForm')"
                  :loading="submitLoading"
                  >确认</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div class="recognition-detail" v-if="showVisit && isEdit != 'visit'">
        <div class="detail-tit">
          带看信息<span @click="edit('visit')" v-if="flowStatus != '签约'"
            >管理</span
          >
        </div>
        <div class="flex reservation-items">
          <div class="reservation-item">
            <el-form-item prop="visitTime" label="带看日期">
              <span>{{ visitInfo.visitTime | nullValue }}</span>
            </el-form-item>
            <el-form-item prop="brokerName" label="陪看人">
              <span>{{ visitInfo.brokerName | nullValue }}</span>
            </el-form-item>
          </div>
          <div class="reservation-item">
            <el-form-item
              prop="materials"
              label="确认带看单"
              class="auto-height margin-bottom"
            >
              <div class="visit-img" v-if="visitInfo.materials.length">
                <el-image
                  class="photo-item"
                  v-for="(item, index) in visitInfo.materials"
                  :key="index"
                  :src="item.url"
                ></el-image>
              </div>
              <div v-else>—</div>
            </el-form-item>
          </div>
        </div>
        <div class="flex reservation-items">
          <el-form-item prop="more" label="备注">
            <span>{{ visitInfo.more | nullValue }}</span>
          </el-form-item>
        </div>
      </div>
      <div class="recognition-detail" v-if="showVisit && isEdit == 'visit'">
        <div class="detail-tit">带看信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="visitTime" label="带看日期">
              <el-date-picker
                v-model="visitInfo.visitTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="brokerId" label="陪看人">
              <el-select
                v-model="visitInfo.brokerId"
                clearable
                filterable
                remote
                reserve-keyword
                :remote-method="getUsersSearch"
                :loading="selectLoading"
                @change="getCustomerInfo"
                placeholder="请选择陪看人"
              >
                <el-option
                  v-for="item in users"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="带看确认单" class="auto-height">
              <div class="visit-img">
                <div
                  class="photo-item"
                  v-for="(item, index) in visitInfo.materials"
                  :key="index"
                >
                  <div class="img-box">
                    <img :src="item.url" class="photo-img" />
                    <div class="del-btn">
                      <span @click="delPhotoItme(index, 'materials')"
                        >删除</span
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="photo-item"
                  v-for="(item, index) in uploadPhotoList"
                  :key="index"
                >
                  <div class="img-box">
                    <img :src="item.url" class="photo-img" />
                    <div class="del-btn">
                      <span @click="delPhotoItme(index)">删除</span>
                    </div>
                  </div>
                </div>
                <el-upload
                  ref="upload"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :on-change="handlePictureCardPreview"
                  :file-list="uploadPhotoList"
                  :show-file-list="false"
                  :auto-upload="false"
                  multiple
                  accept=".jpg, .png, .jpeg"
                >
                  <div class="upload-btn">
                    <i slot="default" class="el-icon-plus"></i>
                    <span>最多上传5张图片</span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="btn-box">
            <el-button
              type="primary"
              @click="submit('visitInfo')"
              :loading="submitLoading"
              >提交</el-button
            >
            <el-button @click="closeEdit">取消</el-button>
          </div>
        </el-row>
      </div>
      <div
        class="recognition-detail"
        v-if="showRecognition && isEdit != 'recognition'"
      >
        <div class="detail-tit">
          认购信息<span @click="edit('recognition')" v-if="flowStatus != '签约'"
            >{{ flowStatus }}管理</span
          >
        </div>
        <div class="flex reservation-items">
          <div class="reservation-item">
            <el-form-item prop="creationTime" label="认购日期">
              <span>{{ recognitionInfo.creationTime | nullValue }}</span>
            </el-form-item>
            <el-form-item prop="number" label="认购数量">
              <span>{{ recognitionInfo.number | nullValue }}</span>
            </el-form-item>
          </div>
          <div class="reservation-item">
            <el-form-item
              prop="materials"
              label="认购合同"
              class="auto-height margin-bottom"
            >
              <div class="visit-img" v-if="recognitionInfo.materials.length">
                <el-image
                  class="photo-item"
                  v-for="(item, index) in recognitionInfo.materials"
                  :key="index"
                  :src="item.url"
                ></el-image>
              </div>
              <div v-else>—</div>
            </el-form-item>
          </div>
        </div>
      </div>
      <div
        class="recognition-detail"
        v-if="showRecognition && isEdit == 'recognition'"
      >
        <div class="detail-tit">认购信息</div>
        <el-row>
          <el-col :span="12">
            <el-form
              :model="recognitionInfo"
              ref="recognitionInfo"
              label-width="6rem"
              label-position="left"
              class="recognition-form"
            >
              <el-form-item prop="Number" label="数量" class="auto-height">
                <el-input
                  class="reason-box"
                  v-model="recognitionInfo.number"
                  type="number"
                >
                  <template slot="append">套</template>
                </el-input>
              </el-form-item>
              <el-form-item label="认购材料" class="auto-height">
                <div class="visit-img">
                  <div
                    class="photo-item"
                    v-for="(item, index) in recognitionInfo.materials"
                    :key="index"
                  >
                    <div class="img-box">
                      <img :src="item.url" class="photo-img" />
                      <div class="del-btn">
                        <span
                          @click="delRecognitionPhotoItme(index, 'materials')"
                          >删除</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="photo-item"
                    v-for="(item, index) in uploadPhotoList"
                    :key="index"
                  >
                    <div class="img-box">
                      <img :src="item.url" class="photo-img" />
                      <div class="del-btn">
                        <span @click="delRecognitionPhotoItme(index)"
                          >删除</span
                        >
                      </div>
                    </div>
                  </div>
                  <el-upload
                    ref="upload"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-change="handlePictureCardPreview"
                    :file-list="uploadReservationsPhotoList"
                    :show-file-list="false"
                    :auto-upload="false"
                    multiple
                    accept=".jpg, .png, .jpeg"
                  >
                    <div class="upload-btn">
                      <i slot="default" class="el-icon-plus"></i>
                      <span>最多上传5张图片</span>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item
                prop="refusedReason"
                label="备注"
                class="auto-height"
              >
                <el-input
                  class="reason-box"
                  type="textarea"
                  v-model="recognitionInfo.refusedReason"
                  maxlength="200"
                  placeholder="请输入备注"
                  show-word-limit
                  resize="none"
                ></el-input>
              </el-form-item>
              <el-form-item class="btn">
                <el-button @click="closeEdit">取消</el-button>
                <el-button
                  type="primary"
                  @click="submitRecognitionInfo('recognitionInfo')"
                  :loading="submitLoading"
                  >确认</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div class="reservation-detail" v-if="contracts.length>0">
        <div class="detail-tit">客户联系人<span class="show-contracts" v-if="permissions['Customer.LookPhoneNumber']" @click="showContracts">查看联系方式</span></div>
        <div class="flex reservation-items">
          <el-table :data="contracts" border>
            <el-table-column prop="name" label="姓名"> </el-table-column>
            <el-table-column prop="gender" label="性别"> </el-table-column>
            <el-table-column prop="phoneNumber" label="电话"> </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="reservation-detail">
        <div class="detail-tit">报备信息</div>
        <div class="flex reservation-items">
          <div class="reservation-item">
            <el-form-item label="到访日期">
              <span>{{ reservationInfo.visitTime | nullValue }}</span>
            </el-form-item>
          </div>
          <div class="reservation-item">
            <el-form-item label="到访人数">
              <span>{{ reservationInfo.visitPersonNumber | nullValue }}</span>
            </el-form-item>
          </div>
        </div>
        <div class="flex reservation-items">
          <div
            class="reservation-item"
            v-for="(item, index) in reservationInfo.fields"
            :key="index"
          >
            <el-form-item :label="item.name">
              <div v-if="item.fieldType == '上传附件'">
                <div v-if="item.savedContent.length">
                  <div v-if="item.savedContent.length == 1">
                    <div
                      v-for="(item, index) in item.savedContent"
                      :key="index"
                      class="flex"
                    >
                      <div class="file-item flex">
                        <el-image
                          :ref="item.fileId"
                          :src="item.url"
                          :preview-src-list="[item.url]"
                        >
                        </el-image>
                        <span>{{ item.name }}</span>
                        <span
                          class="theme-color down-btn"
                          @click="downFile(item.fileId, item.name)"
                          >下载</span
                        >
                      </div>
                    </div>
                  </div>
                  <el-popover placement="top-start" trigger="hover">
                    <div>
                      <div
                        v-for="(el, i) in item.savedContent"
                        :key="i"
                        class="flex-between file-item pop-file"
                      >
                        <div class="flex">
                          <el-image
                            :ref="el.id"
                            v-if="el.fileType == 'image'"
                            :src="el.url"
                            :preview-src-list="[el.url]"
                          >
                          </el-image>
                          <img
                            src="@/assets/image/file-cover.png"
                            v-else
                            class="file-doc file-photo"
                          />
                          <span>{{ el.name }}</span>
                        </div>
                        <span
                          class="theme-color down-btn"
                          @click="downFile(el.fileId, el.name)"
                          >下载</span
                        >
                      </div>
                    </div>
                    <span
                      v-show="item.savedContent.length > 1"
                      class="file-itmes theme-color"
                      slot="reference"
                    >
                      <i class="el-icon-paperclip"></i>
                      <span>{{ item.savedContent.length }}</span
                      >个附件
                    </span>
                  </el-popover>
                </div>
                <div v-else>—</div>
              </div>
              <span v-else-if="item.fieldType == '日期选择'">{{
                item.savedContent | dayFormat
              }}</span>
              <span v-else-if="item.fieldType == '数字输入'">{{
                item.savedContent ? item.savedContent + item.content : "—"
              }}</span>
              <span v-else>{{ item.savedContent | nullValue }}</span>
            </el-form-item>
          </div>
        </div>
        <div class="flex reservation-items">
          <el-form-item label="备注说明">
            <span>{{ reservationInfo.more | nullValue }}</span>
          </el-form-item>
        </div>
      </div>
      <div class="flow-detail">
        <div class="detail-tit">进度</div>
        <div class="flow-list">
          <div class="flow" v-for="(item, index) in flowList" :key="index">
            <span class="tag"></span>
            <div class="img">
              <img src="@/assets/image/default-head.png" alt="" />
            </div>
            <div class="flow-info">
              <div class="flow-name">
                <div>
                  {{ item.flowStatus }}
                  <span v-if="refund&&index==0">（已退）</span>
                </div>
              </div>
              <div class="flow-ceater">
                <div class="tit">
                  <div>
                    {{ item.organizationUnit ? item.organizationUnit + "-" : ""
                    }}{{ item.creatorName }}
                  </div>
                </div>
                <div>{{ item.creationTime }}</div>
              </div>

              <div class="flow-reason" v-if="item.refusedReason">
                <div class="tit">原因</div>
                <div>{{ item.refusedReason }}</div>
              </div>
              <div class="flow-reason">
                <div>{{ item.operationLog }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import {
  getReservationInfo,
  getRecognitionInfo,
  getFlowList,
  getVisitionInfo,
  updateVisitInfo,
  uploadVisitMaterials,
  updateRecognition,
  getNetSign,
  updateNetsign,
  uploadNetSignMaterials,
  downloadMterial,
  getCustomerPhone,
} from "@/http/api/reservations";
import { getReservationRule } from "@/http/api/marketing";
import { getCustomers, } from "@/http/api/customer";
import { get } from "js-cookie";
import { deepCopy } from "@/utils/deepCopy";
import { getUsersSearch, getUserPublicDetails } from "@/http/api/employe";
export default {
  components: {
    headerTop,
  },
  data() {
    return {
      id: this.$route.params.id,
      isEdit: this.$route.query.type ? this.$route.query.type : "",
      reservationInfo: {},
      recognitionInfo: {}, //认筹认购信息
      visitInfo: {},
      selectLoading: false,
      refund:false,
      customers: [],
      flowList: [],
      flowStatus: "",
      users: [],
      ruleInfo: {},
      uploadPhotoList: [],
      uploadReservationsPhotoList: [],
      netsignInfo: {},
      netsignForm: {},
      contracts:[],
      submitLoading: false,
      showRecognition: false,
      showNetsign: false,
      showVisit: false,
      permissions: {},
      netSignRules: {
        unitNumber: [
          {
            required: true,
            trigger: "blur",
            message: "请输入单元",
          },
        ],
        buildingNumber: [
          {
            required: true,
            trigger: "blur",
            message: "请输入楼栋",
          },
        ],
        houseNumber: [
          {
            required: true,
            trigger: "blur",
            message: "请输入房号",
          },
        ],
        price: [
          {
            required: true,
            trigger: "blur",
            message: "请输入成交价格",
          },
        ],
        netSignTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择成交日期",
          },
        ],
        netSignTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择成交日期",
          },
        ],
        reportId: [
          {
            required: true,
            trigger: "change",
            message: "请选择报备单",
          },
        ],
      },
    };
  },
  mounted() {
    this.refund = this.$route.query.refund;
    this.getReservationInfo();
    this.getCustomers();
    this.getRecognitionInfo();
    this.getFlowList();
    this.getVisitionInfo();
    this.getUsersSearch();
    this.getNetSign();    
    this.permissions = this.$store.getters.permissions;
  },
  methods: {
    showContracts(){
       if (this.permissions["Customer.LookPhoneNumber"]) {
        getCustomerPhone(this.id).then((res) => {
          //console.log(res, "联系人");
          this.contracts = res.result.contracts;
        });
      }
    },
    // 下载附件
    downFile(id, name) {
      downloadMterial(id, { fileName: name }).then((res) => {
        const content = res;
        const blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = name;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, name);
        }
      });
    },
    edit(val) {
      this.isEdit = val;
      if (val == "netsign") {
        this.netsignForm = deepCopy(this.netsignInfo);
      }
    },
    closeEdit() {
      this.isEdit = "";
    },
    submitanetsignForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          let netsign = {
            netSignTime: this.netsignForm.netSignTime,
            price: this.netsignForm.price,
            more: this.netsignForm.more,
            buildingNumber: this.netsignForm.buildingNumber,
            unitNumber: this.netsignForm.unitNumber,
            houseNumber: this.netsignForm.houseNumber,
          };
          updateNetsign(this.id, this.netsignForm.flowId, netsign)
            .then((res) => {
              let formData = new FormData();
              formData.append("SourceType", "Accessory");
              this.submitLoading = false;
              this.uploadPhotoList.map((el, i) => {
                //console.log(el, 332211);
                formData.append(`materials[${i}].File`, el.file);
                formData.append(`materials[${i}].Type`, "签约");
              });
              this.netsignForm.materials.map((el, i) => {
                formData.append(
                  `materials[${i + this.uploadPhotoList.length}].Id`,
                  el.id
                );
              });
              if (res) {
                this.$message.success({
                  message: res.message,
                  showClose: true,
                });
              }
              //console.log(formData, 885522);
              uploadNetSignMaterials(
                this.id,
                this.netsignForm.flowId,
                formData
              ).then((res) => {
                this.isEdit = "";
                this.uploadPhotoList = [];
              });
            })
            .catch((err) => {
              this.submitLoading = false;
            });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    submitRecognitionInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          let formData = new FormData();
          formData.append(`More`, this.recognitionInfo.refusedReason);
          formData.append(`Number`, this.recognitionInfo.number);
          formData.append(`FlowId`, this.recognitionInfo.flowId);
          this.uploadPhotoList.map((el, i) => {
            //console.log(el, 987);
            formData.append(`materials[${i}].File`, el.file);
            formData.append(`materials[${i}].Type`, "带看");
          });
          this.recognitionInfo.materials.map((el, i) => {
            formData.append(
              `materials[${i + this.uploadPhotoList.length}].Id`,
              el.id
            );
          });

          formData.append("SourceType", "Accessory");
          updateRecognition(this.id, formData)
            .then((res) => {
              let formData = new FormData();
              this.submitLoading = false;
              if (res) {
                this.$message.success({
                  message: res.message,
                  showClose: true,
                });
              }
              this.isEdit = "";
              this.uploadPhotoList = [];
            })
            .catch((err) => {
              this.submitLoading = false;
            });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          let visitInfo = {
            brokerId: this.visitInfo.brokerId,
            organizationUnit: this.visitInfo.organizationUnit,
            brokerName: this.visitInfo.brokerName,
            visitTime: this.visitInfo.visitTime,
            more: this.visitInfo.more,
          };
          updateVisitInfo(this.id, this.visitInfo.id, visitInfo)
            .then((res) => {
              let formData = new FormData();
              formData.append("SourceType", "Accessory");
              this.submitLoading = false;
              this.uploadPhotoList.map((el, i) => {
                //console.log(el, 987);
                formData.append(`materials[${i}].File`, el.file);
                formData.append(`materials[${i}].Type`, "带看");
              });
              this.visitInfo.materials.map((el, i) => {
                formData.append(
                  `materials[${i + this.uploadPhotoList.length}].Id`,
                  el.id
                );
              });
              if (res) {
                this.$message.success({
                  message: res.message,
                  showClose: true,
                });
              }
              uploadVisitMaterials(this.id, this.visitInfo.id, formData).then(
                (res) => {
                  this.isEdit = "";
                  this.uploadPhotoList = [];
                  this.getVisitionInfo();
                }
              );
            })
            .catch((err) => {
              this.submitLoading = false;
            });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除相册
    delRecognitionPhotoItme(index, val) {
      if (val) {
        this.recognitionInfo.materials.splice(index, 1);
      } else {
        this.uploadPhotoList.splice(index, 1);
      }
    },
    // 删除相册
    delPhotoItme(index, val) {
      if (val) {
        //console.log(this.visitInfo.materials, 888);
        this.visitInfo.materials.splice(index, 1);
        //console.log(this.visitInfo.materials, 999);
      } else {
        this.uploadPhotoList.splice(index, 1);
      }
    },
    handlePictureCardPreview(file) {
      if (this.uploadPhotoList.length < 5) {
        this.uploadPhotoList.push({
          file: file.raw,
          url: URL.createObjectURL(file.raw),
          checked: false,
          type: "",
          error: false,
        });
      } else {
        this.$message({
          message: "最多只允许上传5张图片",
          showClose: true,
        });
      }
    },
    getCustomerInfo(val) {
      getUserPublicDetails(val).then((res) => {
        if (res && res.result) {
          //console.log(res.result, 111);
          this.visitInfo.brokerId = res.result.id;
          this.visitInfo.brokerName = res.resultl.name;
          this.visitInfo.organizationUnit = res.result.organizationUnit;
        }
      });
    },
    //获取客源
    getUsersSearch(val) {
      let query = "";
      // visitInfo.brokerId
      if (val) {
        query = `Filter = ${val}&maxResultCount= 200`;
      } else {
        query = `maxResultCount= 100`;
      }
      getUsersSearch(query).then((res) => {
        this.users = res.result.items;
        //console.log(res, "estates", this.users);
      });
    },
    toReservation() {
      this.$router.push({ path: "/reservation/index" });
    },
    //获取最后一次带看
    getVisitionInfo() {
      getVisitionInfo(this.id)
        .then((res) => {
          if (res.code == 10200) {
            this.visitInfo = res.result;
            this.showVisit = true;
          }
        })
        .catch((err) => {
          this.showVisit = false;
        });
    },
    //获取客源
    getCustomers(val) {
      let query = {
        searchWord: val,
        maxResultCount: 30,
      };
      if (this.searchValue) {
        query.searchWord = this.searchValue;
        query.intention = this.searchKey;
      }

      getCustomers(query).then((res) => {
        this.customers = res.result.items;
        //console.log(res, "estates", this.customers);
      });
    },
    //报备信息
    getReservationInfo() {
      getReservationInfo(this.id).then((res) => {
        if (res.code == 10200) {
          this.reservationInfo = res.result;
          this.ruleInfo = res.result.ruleInfo;
          this.contracts = res.result.contracts
          this.reservationInfo.fields.map((el) => {
            if (el.fieldType == "上传附件" && el.savedContent) {
              el.savedContent = JSON.parse(el.savedContent);
            }
          });
          console.log(this.reservationInfo, "this.reservationInfo");
        }
      });
    },
    // // 获取报备规则
    // getReservationRule(estateId) {
    //   getReservationRule(estateId).then((res) => {
    //     if (res.result.protectedUnit) {
    //       this.ruleInfo = res.result;
    //     }
    //   });
    // },
    //签约信息
    getNetSign() {
      getNetSign(this.id)
        .then((res) => {
          this.netsignInfo = res.result;
          this.showNetsign = true;
          //console.log(this.showNetsign, 9888777);
        })
        .catch((err) => {
          this.showNetsign = false;
        });
    },

    handleNetSignPreview(file) {
      if (this.uploadPhotoList.length < 5) {
        this.uploadPhotoList.push({
          file: file.raw,
          url: URL.createObjectURL(file.raw),
          checked: false,
          type: "",
          error: false,
        });
      } else {
        this.$message({
          message: "最多只允许上传5张图片",
          showClose: true,
        });
      }
    },
    delNetSignPhotoItme(index) {
      if (val) {
        this.netsignForm.materials.splice(index, 1);
      } else {
        this.uploadPhotoList.splice(index, 1);
      }
    },
    //认筹认购信息
    getRecognitionInfo() {
      getRecognitionInfo(this.id)
        .then((res) => {
          this.recognitionInfo = res.result;
          this.showRecognition = true;
        })
        .catch((err) => {
          this.showRecognition = false;
        });
    },
    //进度
    getFlowList() {
      getFlowList(this.id).then((res) => {
        this.flowList = res.result.items;
        if (res.result.items.length > 0) {
          this.flowStatus = res.result.items[0].flowStatus;
        }
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
@mixin tit {
  margin-bottom: 20px;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  color: #666666;
  font-size: 16px;
}
#visit {
  .el-form {
    padding: 20px;
    background: #f3f6fc;
    ::v-deep .visit-img {
      @include flex(row, center);
      flex-wrap: wrap;
      .el-upload {
        border: 1px dashed #e0e0e0;
        border-radius: $--border-radius-base;
        width: 124px;
        height: 84px;
        line-height: 84px;
        .upload-btn {
          @include flex(column, center);
          justify-content: center;
          height: 84px;
          line-height: 84px;
          color: #858585;
          .el-icon-plus {
            font-size: 20px;
          }
          span {
            height: 30px;
            line-height: 30px;
            font-size: 12px;
          }
        }
      }
      .photo-item {
        position: relative;
        margin-right: 20px;
        margin-bottom: 10px;
        width: 124px;
        height: 84px;
        line-height: 84px;
        transition: all 0.4s;
        .del-btn {
          position: absolute;
          top: 0;
          left: 0;
          width: 124px;
          height: 84px;

          background-color: transparent;
          transition: all 0.4s;
          span {
            position: absolute;
            right: 5px;
            bottom: 5px;
            height: 14px;
            line-height: 14px;
            cursor: pointer;
            color: transparent;
          }
        }

        &:hover {
          .del-btn {
            background-color: rgba(0, 0, 0, 0.5);
            span {
              color: #fff;
            }
          }
        }

        img {
          width: 124px;
          height: 84px;
        }
      }
    }
    .btn-box {
      padding: 20px;
      text-align: center;
      background: #fff;
    }
    .visit-detail,
    .reservation-detail,
    .basics-deail,
    .recognition-detail,
    .netsign-detail,
    .flow-detail {
      margin-bottom: 20px;
      border-radius: $--border-radius-base;
      background: #fff;
      .detail-tit {
        @include tit;
        @include flex(row, center);
        justify-content: space-between;
        .show-contracts{
          margin-right: 20px;
        }
        span {
          color: $--color-primary;
          cursor: pointer;
        }
      }

      .el-col {
        padding: 0 20px;
        ::v-deep .el-date-editor {
          .el-input__inner {
            padding-left: 30px;
          }
          .el-icon-circle-close {
            right: 0;
          }
        }
      }
      .estate-info {
        @include flex(row, center);
        justify-content: space-between;
        padding: 20px;
        background: #f7f7f7;
        .estate-main {
          @include flex(row, center);
          .estate-cover {
            margin-right: 30px;
            width: 160px;
            height: 116px;
          }
          .edtate-detail {
            @include flex(column, flex-start);
            justify-content: space-between;
            height: 116px;
            .name,
            .address {
              color: #444;
              .status {
                margin-left: 30px;
                // display: inline-block;
                padding: 2px 5px;
                border-radius: $--border-radius-base;
                font-size: 12px;
                color: #fff;
                background: $--color-primary;
              }
            }
            .info {
              color: #888;
            }
          }
        }
        .estate-price {
          font-size: 26px;
          color: $--color-primary;
        }
      }
      .flow-list {
        padding: 20px 40px;
        .flow {
          @include flex(row, flex-start);
          position: relative;
          padding: 0 20px;
          border-left: 1px solid #e0e0e0;
          padding-bottom: 20px;
          .tag {
            position: absolute;
            left: -4px;
            top: 0;
            padding: 3px;
            border: 1px solid $--color-primary;
            border-radius: 50%;
            background: #fff;
          }
          .img {
            margin-right: 20px;
            img {
              border-radius: 50%;
              width: 48px;
              height: 48px;
            }
          }
          .flow-info {
            .flow-name,
            .flow-ceater,
            .flow-reason {
              @include flex(row, center);
              margin-bottom: 14px;
              color: #666666;
              .tit {
                @include flex(row, center);
                // width: 150px;
              }
              div {
                padding-right: 10px;
              }
            }
            .flow-name {
              color: $--color-primary;

              span{
                color: #999;
              }
            }
          }
        }
        .flow:last-child {
          border-left: 0px;
          .tag {
            border: 1px solid #979797;
          }
        }
      }
      .recognition-form,
      .netsign-form {
        background: #fff;
      }
      .netsign-form {
        .el-textarea {
          width: 415px;
        }

        .build-tit {
          margin-bottom: 10px;
          font-size: 14px;
          color: #000;
        }

        .selset-report {
          cursor: pointer;
          font-size: 14px;
          color: $--color-primary;
        }

        .house-info {
          @include flex(row, center);
          margin-bottom: 10px;

          .el-form-item {
            margin-bottom: 0;
          }

          .el-input {
            width: 60px;
          }

          .unit {
            margin: 0 8px;
            color: #7d7d7d;
          }

          .el-button {
            &:hover {
              color: $--color-primary;
            }
          }

          .delete {
            display: none;
          }

          &:hover {
            .delete {
              display: block;
            }
          }
        }

        .house-info:last-child {
          margin-bottom: 0;
        }

        .el-input {
          width: 180px;
        }

        .visit-img {
          @include flex(row, center);
          flex-wrap: wrap;

          ::v-deep .el-upload {
            border: 1px dashed #e0e0e0;
            border-radius: $--border-radius-base;
            width: 124px;
            height: 84px;
            line-height: 84px;

            .upload-btn {
              @include flex(column, center);
              justify-content: center;
              height: 84px;
              line-height: 84px;
              color: #858585;

              .el-icon-plus {
                font-size: 20px;
              }

              span {
                height: 30px;
                line-height: 30px;
                font-size: 12px;
              }
            }
          }

          .photo-item {
            position: relative;
            margin-right: 20px;
            width: 124px;
            height: 84px;
            line-height: 84px;
            transition: all 0.4s;

            .del-btn {
              position: absolute;
              top: 0;
              left: 0;
              width: 124px;
              height: 84px;

              background-color: transparent;
              transition: all 0.4s;

              span {
                position: absolute;
                right: 5px;
                bottom: 5px;
                height: 14px;
                line-height: 14px;
                cursor: pointer;
                color: transparent;
              }
            }

            &:hover {
              .del-btn {
                background-color: rgba(0, 0, 0, 0.5);

                span {
                  color: #fff;
                }
              }
            }

            img {
              width: 124px;
              height: 84px;
            }
          }
        }
      }
    }

    .btn-box {
      padding: 20px;
      text-align: center;
      background: #fff;
    }

    .reservation-items {
      align-items: flex-start;
      flex-wrap: wrap;
      padding: 0 40px ;
      .el-table{
        margin-bottom: 20px;
      }
      .reservation-item {
        width: 50%;

        .margin-bottom {
          margin-bottom: 0;
        }
      }
    }
  }
}

.file-item {
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #000;

  &:last-child {
    margin-bottom: 0;
  }

  .el-image,
  img {
    margin-right: 10px;
    width: 30px;
    height: 30px;
  }

  span {
    display: inline-block;
    max-width: 260px;
    white-space: nowrap; /*内容超宽后禁止换行显示*/
    overflow: hidden; /*超出部分隐藏*/
    text-overflow: ellipsis; /*文字超出部分以省略号显示*/
  }

  i {
    margin-left: 5px;
    cursor: pointer;
  }

  &.pop-file {
    width: 340px;
  }

  .down-btn {
    display: inline-block;
    margin-left: 10px;
  }
}
</style>
